import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext.shared";

export function MaybeAssignedValue() {
  const workoutItemSetContext = useWorkoutItemSetContext();
  return workoutItemSetContext.renderAssignedValue();
}
